<template>
  <div class="v-quick-clear" @click.stop="clearTxt()" :style="{ right: right+'px' }">
    <span>×</span>
  </div>
</template>

<script>
export default {
  name: 'quick-clear',
  props: {
    right: { type: Number, default: 0 },
  },
  methods: {
    clearTxt() {
      this.$emit('clearTxt');
    },
  },
};
</script>

<style lang="scss" scoped>
.v-quick-clear {
  position: absolute;
  right: 0;
  top: 10px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  text-align: center;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.25);
}
</style>
